export default __webpack_public_path__ + "static/stopShareIdea-083515373d2ff72f9d32f52253255c8d.png";